import delegate from "./delegate";
import anime from "animejs/lib/anime.es.js";
import nlp from 'compromise/three';

class ButtonFunctions {
	constructor() {
		// bind
		this.loaderButtonInit = this.loaderButtonInit.bind(this);

		this.init();
	}

	init() {
		// loader button delegation
		delegate({
			selector: '[data-button="loader"]',
			event: 'click',
			handler: (button) => {
				this.loaderButtonInit(button);
			}
		})
	}

	// global functions
	loaderButtonInit(button) {
		if (button.startLoading === undefined) {
			button.startLoading = function () {
				button.classList.add('btn-loader');
				this.#loaderButton(button);
			}.bind(this);
		}

		if (button.getAttribute('data-button-loader-manual') === null) {
			button.startLoading();
		}
	}

	// loader button
	#loaderButton(button) {
		let goingAnimation;
		function goTo(i) {
			return new Promise(function (resolve) {
				const spanWidth = spans[i].offsetWidth;
				goingAnimation = anime({
					targets: reel,
					translateY: -height * i,
					width: spanWidth,
					duration: 400,
					easing: 'easeInOutExpo',
					complete: function () {
						resolve()
					}
				})
			})
		}
		// disable the button
		button.style.pointerEvents = 'none';

		// make a container with the button text
		let container = document.createElement('div');
		container.classList.add('loader-container');

		let reel = document.createElement('div');
		reel.classList.add('loader-reel');

		let spans = [];

		// array of texts to show
		button.textContent = button.textContent.trim();
		const verb = nlp(button.textContent.split(' ')[0]).verbs().toGerund().toTitleCase().text().replace('Is', '').trim() + '...';
		[button.textContent, verb, button.textContent]
			.forEach(function (text) {
				let span = document.createElement('span');
				span.innerHTML = text;
				spans.push(span);
				reel.appendChild(span);
			})
		spans[1].classList.add('loader-title');

		container.innerHTML = button.innerHTML;
		button.innerHTML = '';
		button.appendChild(container);

		// give the container a fixed height
		const height = container.offsetHeight;
		container.style.height = `${height}px`;

		// attach a loader to the container
		let loader_spinner_container = document.createElement('div');
		loader_spinner_container.classList.add('loader-spinner-container');

		let loader = document.createElement('div');
		loader.classList.add("lds-dual-ring", "loader-spinner");
		loader.style.height = `${height}px`;
		loader.style.width = `${height}px`;

		loader_spinner_container.appendChild(loader);
		loader_spinner_container.style.width = '0px';

		container.innerHTML = '';

		container.appendChild(loader_spinner_container);
		container.appendChild(reel);

		const marginRight = 8;

		// animate the loader
		anime({
			targets: loader_spinner_container,
			width: [0, height],
			marginRight: [0, marginRight],
			duration: 400,
			easing: 'easeInOutExpo',
		})

		// animate the reel
		goTo(1);

		// now for completion
		button.finishLoading = function () {
			goingAnimation.pause();

			goTo(2);
			anime({
				targets: loader_spinner_container,
				width: 0,
				marginRight: 0,
				duration: 400,
				easing: 'easeInOutExpo',
				// complete
				complete: function () {
					button.innerHTML = spans[0].innerHTML;
					button.style.pointerEvents = 'auto';
					button.classList.remove('btn-loader');
				}
			})

			// unbind this function
			delete button.onLoaded;
		}
	}
}

export default ButtonFunctions;


